import { axiosEjFetch as axiosFetch } from "./axiosEjHelpers";

export async function createMissingThumbnailsForReservation(
  reservationId: string
) {
  const body = {
    reservationId,
  };
  return axiosFetch.post("/api/tools/createMissingThumbnails", body);
}

export async function createMissingThumbnailsForMedia(ids: string[]) {
  const body = {
    photoIds: ids,
  };
  return axiosFetch.post("/api/tools/createMissingThumbnails", body);
}

export async function updateMediaContent(body: any) {
  return axiosFetch.post("/api/tools/updateMediaContent", body, {
    "Content-Type": "multipart/form-data",
  });
}

export async function transferMedia(
  destReservationId: string,
  mediaIds: string[]
) {
  const body = {
    destinationReservationId: destReservationId,
    mediaIds,
    removeOriginal: true,
  };
  return axiosFetch.post("/api/tools/transferMedia", body);
}

export type UpdateMediaProperty = {
  id: string;
  takenOnUtc: string;
};

export async function updateMediaProperties(updates: UpdateMediaProperty[]) {
  const body = {
    updates,
  };
  return axiosFetch.post("/api/tools/updateMediaProperties", body);
}

export async function recalculateAiCosts(
  onlyEmpty: boolean = true
): Promise<{
  updatedCount: number;
  totalProcessed: number;
  success: boolean;
  errorMessage?: string;
}> {
  const response = await axiosFetch.post("/api/tools/recalculate-ai-costs", {
    onlyEmpty,
  });
  return response.data;
}
